import { api } from './client'

export interface TeaGrade {
    id: string
    code: string
    name: string
    sort_order: number
    is_active: boolean
    created_at: string
    updated_at: string
    // Số lô đang dùng grade này (hydrated ở List, BE tính qua COUNT). FE
    // dùng để disable Delete + hiện tooltip lý do khi > 0.
    sorting_lots_count: number
    scenting_lots_count: number
}

export interface ListTeaGradesParams {
    is_active?: boolean
    search?: string
}

export interface CreateTeaGradeRequest {
    code: string
    name: string
    sort_order?: number
    is_active?: boolean
}

export interface PatchTeaGradeRequest {
    code?: string
    name?: string
    sort_order?: number
    is_active?: boolean
}

export const teaGradeApi = {
    list: (params?: ListTeaGradesParams) =>
        api.get<TeaGrade[]>('/tea-grades', {
            params: params as Record<
                string,
                string | number | boolean | undefined
            >,
        }),
    get: (id: string) => api.get<TeaGrade>(`/tea-grades/${id}`),
    create: (data: CreateTeaGradeRequest) =>
        api.post<TeaGrade>('/tea-grades', data),
    patch: (id: string, data: PatchTeaGradeRequest) =>
        api.patch<TeaGrade>(`/tea-grades/${id}`, data),
    remove: (id: string) => api.delete<{ status: string }>(`/tea-grades/${id}`),
}
